// 게임 목록 페이지(/me/games).
// G1 단계에서는 활성 게임을 안내만 한다(실제 플레이 화면=Phaser 번들 iframe 은 G3 에서 연결).
// games_enabled 가 꺼져 있으면 진입해도 "준비 중" 으로 막는다(킬스위치 일관성).

import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Gamepad2 } from "lucide-react";
import { getGameConfig } from "@/features/games/gamesApi.ts";

// 단일 게임 카드. 입장 가능하면(to) 링크, 아니면 준비 중 안내.
function GameCard({ title, desc, to }: { title: string; desc: string; to?: string }) {
  const body = (
    <>
      <div className="flex items-center gap-2">
        <Gamepad2 size={20} aria-hidden="true" className="text-brand-600" />
        <span className="text-base font-semibold">{title}</span>
      </div>
      <p className="text-sm text-ink-600">{desc}</p>
      <span className="mt-1 inline-flex w-fit rounded-full bg-ink-100 px-2 py-0.5 text-xs text-ink-600">
        {to ? "입장하기" : "곧 만나요"}
      </span>
    </>
  );
  if (to) {
    return (
      <Link to={to} className="flex flex-col gap-1 rounded-md border border-ink-200 p-4 hover:bg-ink-50">
        {body}
      </Link>
    );
  }
  return <div className="flex flex-col gap-1 rounded-md border border-ink-200 p-4">{body}</div>;
}

// 게임 목록 화면. 운영설정으로 켜진 게임만 노출하고, 꺼져 있으면 준비 중으로 막는다.
export default function GamesPage() {
  const configQuery = useQuery({ queryKey: ["game-config"], queryFn: getGameConfig });
  const config = configQuery.data;

  return (
    <main className="mx-auto flex max-w-screen-sm flex-col gap-4 px-4 py-8">
      <h1 className="text-2xl font-bold">게임</h1>

      {configQuery.isLoading ? (
        <p className="text-sm text-ink-600">불러오는 중...</p>
      ) : !config?.gamesEnabled ? (
        <p className="text-sm text-ink-600">아직 준비 중이에요. 곧 즐기실 수 있도록 준비하고 있어요.</p>
      ) : (
        <>
          <p className="text-sm text-ink-600">
            게임을 즐기면 적립금을 드려요. 하루 최대 {config.reward.dailyCapKrw.toLocaleString()}원까지.
          </p>
          <div className="flex flex-col gap-2">
            {config.ranch.enabled ? (
              <GameCard
                title="열린목장"
                desc="동물을 분양받아 키우고 교배해 목장을 꾸며요."
                to="/me/games/ranch"
              />
            ) : null}
            {config.cooking.enabled ? (
              <GameCard title="열린쿠킹" desc="고기 요리를 만들며 다양한 레시피를 배워요." />
            ) : null}
          </div>
        </>
      )}
    </main>
  );
}
